import { msg } from "@lingui/core/macro";
import { Trans, useLingui } from "@lingui/react/macro";
import { createFileRoute } from "@tanstack/react-router";

import { parseSEOMetaLoaderData, seo } from "@/lib/seo";
import CompanyHistory from "@/components/about-us/company-history-section";
import InfoSection from "@/components/about-us/info-section";
import BehindCompanySection from "@/components/about-us/members-section";
import OurImpactSection from "@/components/about-us/our-impact-section";
import VisionSection from "@/components/about-us/vision-section";
import Hero, { HeroTitle } from "@/components/hero";
import InformativeSection from "@/components/shared/informative-section";

import aboutUsHeroBg from "@/assets/images/about-us-hero.jpeg";
import aboutUsHeroBg2x from "@/assets/images/about-us-hero.jpeg";
import believeImage from "@/assets/images/about-us-informative.jpg";
import smallBelieveImage from "@/assets/images/mini-believe.jpeg";

export const Route = createFileRoute("/_default-layout/about-us")({
  loader: ({ context: { i18n }, location }) => {
    return {
      seoMeta: seo({
        i18n,
        path: location.pathname,
        title: msg`About`,
        description: msg`El Safwa specializes in developing residential and mixed-use properties, focusing on vibrant communities and enhancing quality of life. Learn about our 30 years of experience in creating exceptional living spaces.`,
        keywords:
          "El Safwa, real estate development, residential properties, mixed-use properties, luxury resorts, 30 years experience",
      }),
    };
  },
  head: ({ loaderData }) => ({
    meta: [
      ...parseSEOMetaLoaderData(loaderData, {
        title: "About",
      }),
    ],
  }),
  component: AboutUs,
});

function AboutUs() {
  const { t } = useLingui();

  return (
    <div>
      <Hero imageBg={aboutUsHeroBg} imageBg2x={aboutUsHeroBg2x}>
        <HeroTitle linkTo="/about-us" hashID="about-elsafwa">
          <Trans>El Safwa</Trans>
          <br />
          <span className="font-bold">
            <Trans>30+ Years of Experience</Trans>
          </span>
        </HeroTitle>
      </Hero>

      <section
        className="container gap-4 pt-6 pb-12 md:mt-[60px] md:mb-[60px] lg:px-8 lg:pb-8"
        id="about-elsafwa"
      >
        <InfoSection />
      </section>

      <section className="container gap-4 pb-12 md:mb-[60px] lg:px-8 lg:pb-8">
        <OurImpactSection />
      </section>

      <VisionSection />

      <section className="py-6 md:py-[60px]">
        <InformativeSection
          lightTitle={t`What We`}
          boldTitle={t`Believe In`}
          description={t`We’re family-run, proudly independent, and focused on one thing: creating places
Where people don’t just stay—they belong.`}
          tags={[t`Luxury Living Experts`, t`Signature Homes`]}
          smallImage={smallBelieveImage}
          mainImage={believeImage}
          aboutPage
        />
      </section>

      <section className="container mb-[60px] gap-4 md:mt-[60px]">
        <CompanyHistory />
      </section>

      <BehindCompanySection />
    </div>
  );
}
